import { useSearchParams } from "react-router-dom";

/**
 * The URL search params plus a setter for one key (an empty value clears it).
 * Filters live in the URL so a route loader refetches from that one source
 * and the list, its count and its headings can never disagree.
 */
export function useSearchFilter(): [URLSearchParams, (key: string, value: string) => void, (values: Record<string, string>) => void] {
  const [params, setParams] = useSearchParams();
  /** Set several keys in one navigation (a date range is two keys). Empty values clear. */
  const setFilters = (values: Record<string, string>) => {
    const next = new URLSearchParams(params);
    for (const [key, value] of Object.entries(values)) {
      if (value) next.set(key, value);
      else next.delete(key);
    }
    setParams(next);
  };
  const setFilter = (key: string, value: string) => setFilters({ [key]: value });
  return [params, setFilter, setFilters];
}
